import React from 'react';
import { YesNoFilter } from '~/components';
import {
  AllocationFiltersBar,
  ClientFiltersBar,
  MemberFiltersBar,
  ProjectFiltersBar,
  ResourceFiltersBar,
} from '~/components/filters';
import FiltersBarContainer from '../../components/FiltersBar';

export default function FiltersBar({ params, onFilterChange }) {
  return (
    <FiltersBarContainer>
      <YesNoFilter
        icon="filter"
        placeholder="Only projects with allocations"
        value={params.onlyAllocatedProjects ? 'yes' : 'no'}
        onChange={({ target: { value } }) => onFilterChange({ onlyAllocatedProjects: value === 'yes' })}
      />

      <AllocationFiltersBar filters={params} sticky={['allocationBookingTypeId']} onChange={onFilterChange} />

      <ClientFiltersBar filters={params} onChange={onFilterChange} />

      <ProjectFiltersBar filters={params} onChange={onFilterChange} />

      <MemberFiltersBar filters={params} onChange={onFilterChange} />

      <ResourceFiltersBar filters={params} onChange={onFilterChange} />
    </FiltersBarContainer>
  );
}
